export enum EnergyCostTab {
  Outlook = 'OUTLOOK',
  Funding = 'FUNDING',
}
